import {
    AIRPORT_GETALL_SUCCESS,
    AIRPORT_GETALL_FAIL,
    AIRPORT_UPSERT_SUCCESS,
    AIRPORT_UPSERT_FAIL,
    AIRPORT_DELETE_SUCCESS,
    AIRPORT_DELETE_FAIL,
    SET_MESSAGE
  } from "./types";
  
  import AirportService from "../services/airport-service";
  
  export const getAirports = () => (dispatch) => {
    return AirportService.getAirports().then(
      (data) => {
        dispatch({
          type: AIRPORT_GETALL_SUCCESS,
          payload: { airports : data },
        });
        return Promise.resolve();
      },
      (error) => {
        dispatch({ type: AIRPORT_GETALL_FAIL });
        dispatch({
          type: SET_MESSAGE,
          payload: `Airport retrieval failed : ${error}`,
        });
        return Promise.reject();
      }
    );
  };
  
  export const upsertAirport = (airport) => (dispatch) => {
    return AirportService.upsertAirport(airport).then(
      (data) => {
        dispatch({ type: AIRPORT_UPSERT_SUCCESS, payload: data });
        return Promise.resolve();
      },
      (error) => {
        dispatch({ type: AIRPORT_UPSERT_FAIL });
        dispatch({
          type: SET_MESSAGE,
          payload: `Airport upsert failed - ${error}`,
        });
        return Promise.reject();
      }
    );
  };
  
  export const deleteAirport = (airport_id) => (dispatch) => {
    return AirportService.deleteAirport(airport_id).then(
      () => {
          dispatch({ type: AIRPORT_DELETE_SUCCESS, payload : airport_id });
          return Promise.resolve();

      },
      (error) => {
          dispatch({ type: AIRPORT_DELETE_FAIL });
          dispatch({ type: SET_MESSAGE, payload: `Airport upsert failed - ${error}` });
          return Promise.reject();
      }
    );
  };